import * as React from "react";
import { Route } from "react-router";
import Admin from "./views/Admin";
import Businesses from "./views/Businesses";
import CarsForSaleTable from "./views/CarsForSaleTable";
import CheckIns from "./views/CheckIns";
import Dashboard from "./views/Dashboard";
import HTMLGenerator from "./views/HTMLGenerator";
import JustIn from "./views/JustIn";
import PricesTable from "./views/PricesTable";
import ProMembers from "./views/ProMembers";
import Reports from "./views/Reports";
import ScheduledReports from "./views/ScheduledReports";
import Tables from "./views/Tables";
import Users from "./views/Users";
import WheelOptions from "./views/WheelOptions";
import Wheels from "./views/Wheels";

const AdminRoute = {
  component: (
    <Route key="admin" path="/admin">
      <Admin />
    </Route>
  ),
  path: "admin",
};
const BusinessesRoute = {
  component: (
    <Route key="businesses" path="/businesses">
      <Businesses />
    </Route>
  ),
  path: "businesses",
};
const CheckInsRoute = {
  component: (
    <Route key="check-ins" path="/check-ins">
      <CheckIns />
    </Route>
  ),
  path: "check-Ins",
};
const DashboardRoute = {
  component: (
    <Route key="dashboard" path="/dashboard">
      <Dashboard />
    </Route>
  ),
  path: "dashboard",
};
const HTMLGeneratorRoute = {
  component: (
    <Route key="html-generator" path="/html-generator">
      <HTMLGenerator />
    </Route>
  ),
  path: "html-generator",
};

const JustInRoute = {
  component: (
    <Route
      key="just-in"
      path="/just-in/:business?/:site?/:mobile?"
      render={(props) => <JustIn {...props} />}
    />
  ),
  path: "just-in",
};

const WheelRoute = {
  component: (
    <Route key="wheel" path="/wheel">
      <Wheels />
    </Route>
  ),
  path: "wheel",
};

const WheelOptionRoute = {
  component: (
    <Route key="wheel-options" path="/wheel-options">
      <WheelOptions />
    </Route>
  ),
  path: "wheel-options",
};

const ReportsRoute = {
  component: (
    <Route key="reports" path="/reports">
      <Reports />
    </Route>
  ),
  path: "reports",
};

const ScheduledReportsRoute = {
  component: (
    <Route key="scheduled-reports" path="/scheduled-reports">
      <ScheduledReports />
    </Route>
  ),
  path: "scheduled-reports",
};

const ProMembersRoute = {
  component: (
    <Route key="pro-members" path="/pro-members">
      <ProMembers />
    </Route>
  ),
  path: "pro-members",
};

const TablesRoute = {
  component: (
    <Route
      key="tables"
      path="/tables/:business?/:site?/:table?"
      render={(props) => <Tables {...props} />}
    />
  ),
  path: "tables",
};
const PricesTablesRoute = {
  component: (
    <Route
      key="prices-table"
      path="/prices-table/:business?/:site?/:table?"
      render={(props) => <PricesTable {...props} />}
    />
  ),
  path: "tables",
};
const CarsForSaleRoute = {
  component: (
    <Route
      key="cars-for-sale-table"
      path="/cars-for-sale-table/:business?/:site?/:table?"
      render={(props) => <CarsForSaleTable {...props} />}
    />
  ),
  path: "tables",
};
const UsersRoute = {
  component: (
    <Route key="users" path="/users">
      <Users />
    </Route>
  ),
  path: "users",
};

export const userPaths = [];
export const staffPaths = [...userPaths, CheckInsRoute.path];
export const ownerPaths = [...staffPaths, ReportsRoute.path];
export const adminPaths = [
  DashboardRoute.path,
  ...ownerPaths,
  BusinessesRoute.path,
  ProMembersRoute.path,
  UsersRoute.path,
  ScheduledReportsRoute.path,
  WheelOptionRoute.path,
];

export const userRoutes = [
  JustInRoute.component,
  CarsForSaleRoute.component,
  TablesRoute.component,
  PricesTablesRoute.component,
  WheelRoute.component,
];
export const staffRoutes = [...userRoutes, CheckInsRoute.component];
export const ownerRoutes = [...staffRoutes, ReportsRoute.component];
export const adminRoutes = [
  DashboardRoute.component,
  ...ownerRoutes,
  BusinessesRoute.component,
  ProMembersRoute.component,
  UsersRoute.component,
  ScheduledReportsRoute.component,
  ProMembersRoute.component,
  WheelOptionRoute.component,
];

if (process.env.NODE_ENV === "development") {
  adminPaths.push(AdminRoute.path);
  adminRoutes.push(AdminRoute.component);
}

export default {
  BusinessesRoute,
  CheckInsRoute,
  HTMLGeneratorRoute,
  ReportsRoute,
  UsersRoute,
};



// WEBPACK FOOTER //
// ./src/Routes.tsx